import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { MatPaginator } from '@angular/material';
import { IExcel } from 'src/app/models/actualizarExcel'
import { AlertsService } from '../../../services/shared/alerts.service';
import { TabledateService } from '../../../services/tabledate/tabledate.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: "tabledate",
  templateUrl: "./tabledate.component.html",
  styleUrls: ["./tabledate.component.scss"],
})
export class TabledateComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  petition: boolean = false; // I
  isActions: number = 0;
  excelHeaders: string[] = [];
  excelData: any[] = [];
  paginatedExcel: any[] = [];
  currentPage: number = 1;
  pageSize: number = 5;
  uploadedExcelFileNames: string[] = [];
  showUploadedExcelSection = false;
  showExcelListModal: boolean = false;
  responseData: any[] = [];
  actualizados: any[]= [];
  noactualizados: any[]= [];





  constructor(
    private _exceldata : TabledateService,
    private _alert: AlertsService,
  ) {}

  ngOnInit() {
    this.updatePaginator();
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.updatePaginator();
  }

  updatePaginator() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedExcel = this.excelData.slice(startIndex, endIndex);
  }

  updateDisplayedData() {
    this.updatePaginator();
  }


  dragoverFile(event: any) {
    event.preventDefault();
    this.isActions = 1;
  }

  dragEnd(event: any) {
    event.preventDefault();
    this.isActions = 0;
  }

  dropFiles(event: any) {
    event.preventDefault();
    this.isActions = 0;
    this.handleFile(event.dataTransfer.files[0]);
  }

  handleFileInput(event: any) {
    this.handleFile(event.target.files[0]);
  }

  handleFile(file: File) {
    if (this.uploadedExcelFileNames.includes(file.name)) {
      Swal.fire('El archivo Excel ya ha sido subido previamente.');
      return;
    }

    this.petition = true;
    if (
      file &&
      (file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    ) {
      const fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const sheetData: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (sheetData.length > 0) {
          if (sheetData[0].length === 2) {
            this.excelHeaders = sheetData[0].map((header: string) => header.trim());
            this.excelData = sheetData.slice(1);
            this.currentPage = 0;
            this.updateDisplayedData();
            this.petition = false;

            let excelDataToUpload: IExcel[] = [];
            const seen = new Set(); // Utilizamos un Set para identificar datos duplicados
            let hasDuplicates = false;

            this.excelData.forEach(row => {
              const numero = row[0];
              const iccid = row[1];
              if (numero && iccid) {
                const rowData: IExcel = {
                  numero,
                  iccid
                };
                const key = `${numero}-${iccid}`;
                if (seen.has(key)) {
                  hasDuplicates = true;
                  return;
                }
                seen.add(key);

                excelDataToUpload.push(rowData);
              }
            });

            if (hasDuplicates) {
              Swal.fire('Datos duplicados', 'El archivo Excel contiene datos duplicados.', 'warning');
              this.petition = false; // Cancelar la petición
              return;
            }

            console.log("excelDataUpload----------------------------", excelDataToUpload);
            this.uploadedExcelFileNames.push(file.name);

            this._exceldata.postUpdateExcelArray(excelDataToUpload)
              .then(res => {
                this.responseData = res.data;
               
                console.log("responsedata-------", this.responseData);
                for (let i = 0; i < this.responseData.length; i++) {
                  const item = this.responseData[i];
                  if (item.status === 3) {
                    this.actualizados.push({
                      Numero: item.Numero,
                      iccid: item.iccid,
                      status: item.status
                    });
                  } else {
                    this.noactualizados.push({
                      Numero: item.Numero,
                      iccid: item.iccid
                    });
                  }
                }
                if (this.noactualizados.length === 0) {
                  Swal.fire('Datos actualizados');
                  console.log("actualizados----", this.actualizados);

                  this.petition = false;

                }else{
                  Swal.fire('Numero y/o Iccid, no coinciden, Si hay registros que coinciden se actualizarán');
                this.petition = false;
                console.log("noactualizados----",this.noactualizados);

                }
              })
              .catch(error => {
                console.error('Error al enviar los datos:', error);
                Swal.fire('Numero y/o Iccid, no coinciden, Si hay registros que coinciden se actualizan');
                this.petition = false;
              });

          } else {
            Swal.fire('El archivo Excel contiene datos innecesarios.');
            this.petition = false;
          }
        } else {
          Swal.fire('El archivo Excel no contiene datos.');
          this.petition = false;
        }
      };
      fileReader.readAsBinaryString(file);
    } else {
      Swal.fire(
        'Formato de archivo incorrecto. Por favor, selecciona un archivo Excel (.xls o .xlsx).'
      );
      this.petition = false;
    }
    }













showUploadedExcelList() {
  this.showUploadedExcelSection = !this.showUploadedExcelSection;
}

isFileAlreadyUploaded(fileName: string): boolean {
  return this.uploadedExcelFileNames.includes(fileName);
}



  sendFile() {
    this.petition = true;
        this.excelHeaders = [];
        this.excelData = [];
        this.updateDisplayedData();
        this.petition = false;
      }



  openFileInput() {
    const fileInput = document.getElementById('file-upload') as HTMLInputElement;
    fileInput.click();
  }


}
